<template>
<div class='vx-col w-full mt-4'>
  <!-- institucionSelected {{ institucionSelected }} -->
    <vs-alert>Hay {{ listaDocentes.length }} docentes con asignaturas activas en periodo {{ institucionSelected.periodo }} </vs-alert>
    <vs-table max-items="30" stripe search pagination :data="listaDocentes">
        <template slot="thead">
            <vs-th width="25%">Docente</vs-th>
            <vs-th>Asignaturas</vs-th>
        </template>
        <template slot-scope="{data}">
            <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                <vs-td :data="tr.docente">
                    <p> <small>{{ tr.idusuario }} </small></p>
                    <p>{{tr.docente}} </p>
                    <p>{{tr.cedula}} </p>
                </vs-td>
                <vs-td>
                    <p>
                        <vs-chip color="dark">Asignados:  {{ tr.asignaturas.length }}</vs-chip> <br><br>
                    </p>
                    <div class="auto-grid">
                        <div v-for="(asignatura, indexAsig) in tr.asignaturas" :key="indexAsig" class="d-inline align-center m-2 p-2 border-2 asig-select text-dark width-libro-select">
                            {{ asignatura.nombre }} <br><b> {{ institucionSelected.periodo }}</b>
                            <small>({{ asignatura.updated_at }})</small>
                        </div>
                    </div>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
export default {
    props: {

        institucionSelected: {
            type: Object,
            default: () => {}
        }
    },
    components: {},
    data() {
        return {
            listaDocentes: [],
        };
    },
    created() {},
    mounted() {
        this.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            me.$vs.loading()
            let formData = new FormData();
            formData.append('idInstitucion', this.institucionSelected.idInstitucion);
            formData.append('periodo_id', this.institucionSelected.periodo_id);
            this.$http.post(this.$server_url + 'docentes_x_institucion', formData)
                .then(function (res) {
                    me.listaDocentes = res.data
                    // console.log('listaDocentes', me.listaDocentes)
                    me.$vs.loading.close()
                })
                .catch(function (error) {
                    console.log(error)
                    me.$vs.loading.close()
                })

        }
    }
};
</script>

<style scoped>
.width-libro-select {
    display: flex;
    flex-flow: column nowrap;
    padding: 1rem;
    background-image: linear-gradient(to top, rgba(236, 239, 245, 0.5), rgba(223, 228, 236, 0.7));
    border: 1px solid #999;
    border-radius: 5px;
}

.auto-grid {
    display: -ms-grid;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    grid-gap: 1rem;
    /* background-image: linear-gradient(135deg, #D4FFCC 25%, #F2F2F2 25%, #F2F2F2 50%, #D4FFCC 50%, #D4FFCC 75%, #F2F2F2 75%, #F2F2F2 100%); */
    background-size: 50px 50px;
}
</style>
